import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Logo from '../../atoms/Logo'
import Container from '../../containers/Container'
import { useMenuHandles } from '../../contextModels/MenuContext'
import Burger from '../../icons/Burger'
import MainMenu from '../MainMenu'
import * as style from './style.module.scss'

const Header = () => {
    const { isMenuActive, toggleMenu } = useMenuHandles()
    return (
        <StaticQuery
            query={graphql`
                query HeaderQuery {
                    wpMenu(locations: { eq: HEADER_MENU }) {
                        ...Menu
                    }
                }
            `}
            render={(data) => (
                <header className={`${style.header} site-header`}>
                    <Container>
                        <div className={style.headerWrap}>
                            <div className={style.headerWrap_icons}>
                                <Logo to="/" />
                                <div className={style.burgerWrap}>
                                    <Burger
                                        active={isMenuActive}
                                        onClick={toggleMenu}
                                    />
                                </div>
                            </div>
                            <MainMenu menu={data.wpMenu?.menuItems?.nodes} />
                        </div>
                    </Container>
                </header>
            )}
        />
    )
}

export default Header
